import { PopupsContext } from './context'

import type { PromotionKey } from '../_factory/core'
import type { PopupsContextProps } from './context'
import type { PromotionPopups } from './store'


import { useContext } from 'react';
export function useSitePromotionPopupsStoreFactory<
  T extends PromotionPopups,
>() {
  // todo: fix type
  const store = useContext<PopupsContextProps<T>>(PopupsContext as any)
  if (!store) {
    throw new Error(
      'useSitePromotionPopupsStoreFactory must be used within SitePromotionPopupsProvider',
    )
  }
  return store
}

export function useOnClosePopupFactory<T extends PromotionPopups>(
  key: PromotionKey<T>,
  callback: () => void,
) {
  const store = useSitePromotionPopupsStoreFactory()
  store.subscribe((state, prevState) => {
    if (state.openKey === null && prevState.openKey === key) {
      callback()
    }
  })
}
